import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export const useCaseSidebarNavigation = () => {
  const route = useRoute()
  const router = useRouter()

  const isSidebarOpen = computed(() => route.name === 'CaseDetails')

  const closeSidebar = () => router.push({ name: 'Case', params: route.params, query: route.query })

  const openSidebar = () =>
    router.push({ name: 'CaseDetails', params: route.params, query: route.query })

  return { isSidebarOpen, closeSidebar, openSidebar }
}
